import type { RouteLocationRaw } from "vue-router";

export const USER_CENTER_BASE_PATH = "/user-center";

export interface UserCenterRouteDef {
  legacyPath: string;
  nuxtPath: string;
  name: string;
  viewKey: string;
  code?: string;
  title?: string;
  pageTitle?: string;
  requiresAuth?: boolean;
  standalone?: boolean;
  hiddenSider?: boolean;
  fullLayout?: boolean;
}

function createRoute(def: Omit<UserCenterRouteDef, "nuxtPath">): UserCenterRouteDef {
  return {
    ...def,
    nuxtPath: `${USER_CENTER_BASE_PATH}${def.legacyPath}`,
  };
}

export const userCenterRouteDefs: UserCenterRouteDef[] = [
  createRoute({
    legacyPath: "/login",
    name: "UserCenterLogin",
    viewKey: "login",
    title: "登录",
    pageTitle: "登录",
    requiresAuth: false,
    standalone: true,
  }),
  createRoute({
    legacyPath: "/mall/home",
    name: "mallHome",
    viewKey: "mallHome",
    code: "mallHome",
    title: "首页",
    pageTitle: "首页",
  }),
  createRoute({
    legacyPath: "/mall/allOrderList",
    name: "mallAllOrderList",
    viewKey: "mallAllOrderList",
    code: "mallAllOrderList",
    title: "全部订单",
    pageTitle: "全部订单",
  }),
  createRoute({
    legacyPath: "/mall/selectOrderList",
    name: "mallSelectOrderList",
    viewKey: "mallSelectOrderList",
    code: "mallSelectOrderList",
    title: "全部订单",
    pageTitle: "全部订单",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/warehousePackage",
    name: "mallWarehousePackage",
    viewKey: "mallWarehousePackage",
    code: "mallWarehousePackage",
    title: "仓库包裹",
    pageTitle: "仓库包裹",
  }),
  createRoute({
    legacyPath: "/mall/favorites",
    name: "mallFavorites",
    viewKey: "mallFavorites",
    code: "mallFavorites",
    title: "收藏夹",
    pageTitle: "收藏夹",
  }),
  createRoute({
    legacyPath: "/mall/account",
    name: "mallAccount",
    viewKey: "mallAccount",
    code: "mallAccount",
    title: "会员中心",
    pageTitle: "会员中心",
  }),
  createRoute({
    legacyPath: "/mall/message",
    name: "mallMessage",
    viewKey: "mallMessage",
    code: "mallMessage",
    title: "消息中心",
    pageTitle: "消息中心",
  }),
  createRoute({
    legacyPath: "/mall/allOrderDetail",
    name: "mallAllOrderDetail",
    viewKey: "mallAllOrderDetail",
    code: "mallAllOrderDetail",
    title: "订单详情",
    pageTitle: "订单详情",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/tbOrderDetail",
    name: "mallTbOrderDetail",
    viewKey: "mallTbOrderDetail",
    code: "mallTbOrderDetail",
    title: "订单详情",
    pageTitle: "订单详情",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/weidianOrderDetail",
    name: "mallWeidianOrderDetail",
    viewKey: "mallWeidianOrderDetail",
    code: "mallWeidianOrderDetail",
    title: "订单详情",
    pageTitle: "订单详情",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/cart",
    name: "mallCart",
    viewKey: "mallCart",
    code: "mallCart",
    title: "购物车",
    pageTitle: "购物车",
  }),
  createRoute({
    legacyPath: "/mall/confirmation1688Order",
    name: "mallConfirmation1688Order",
    viewKey: "mallConfirmation1688Order",
    code: "mallConfirmation1688Order",
    title: "确认订单",
    pageTitle: "确认订单",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/confirmationWeidianOrder",
    name: "mallConfirmationWeidianOrder",
    viewKey: "mallConfirmationWeidianOrder",
    code: "mallConfirmationWeidianOrder",
    title: "确认订单",
    pageTitle: "确认订单",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/Pay1688Order",
    name: "mallPay1688Order",
    viewKey: "mallPay1688Order",
    code: "mallPay1688Order",
    title: "支付订单",
    pageTitle: "支付订单",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/PayWeidianOrder",
    name: "mallPayWeidianOrder",
    viewKey: "mallPayWeidianOrder",
    code: "mallPayWeidianOrder",
    title: "支付订单",
    pageTitle: "支付订单",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/tbDirectPaymentConfirm",
    name: "mallTbDirectPaymentConfirm",
    viewKey: "mallTbDirectPaymentConfirm",
    code: "mallTbDirectPaymentConfirm",
    title: "确认订单",
    pageTitle: "确认订单",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/tbPayOrder",
    name: "mallTbPayOrder",
    viewKey: "mallTbPayOrder",
    code: "mallTbPayOrder",
    title: "支付订单",
    pageTitle: "支付订单",
    hiddenSider: true,
  }),
  createRoute({
    legacyPath: "/mall/recharge",
    name: "mall1688Recharge",
    viewKey: "mallRecharge",
    code: "mall1688Recharge",
    title: "余额充值",
    pageTitle: "余额充值",
  }),
  createRoute({
    legacyPath: "/collection/mallPackage",
    name: "mallPackage",
    viewKey: "collectionMallPackage",
    code: "mallPackage",
    title: "电商包裹",
    pageTitle: "电商包裹",
  }),
  createRoute({
    legacyPath: "/collection/home",
    name: "CollectionHome",
    viewKey: "collectionHome",
    code: "collectionHome",
    title: "首页",
    pageTitle: "首页",
  }),
  createRoute({
    legacyPath: "/collection/order",
    name: "CollectionOrder",
    viewKey: "collectionOrder",
    code: "collectionOrder",
    title: "集运订单",
    pageTitle: "集运订单",
  }),
  createRoute({
    legacyPath: "/collection/package",
    name: "CollectionPackage",
    viewKey: "collectionPackage",
    code: "collectionPackage",
    title: "集运包裹",
    pageTitle: "集运包裹",
  }),
  createRoute({
    legacyPath: "/collection/forecast",
    name: "CollectionForecast",
    viewKey: "collectionForecast",
    code: "collectionForecast",
    title: "申请预报",
    pageTitle: "申请预报",
  }),
  createRoute({
    legacyPath: "/collection/income",
    name: "CollectionIncome",
    viewKey: "collectionIncome",
    code: "collectionIncome",
    title: "消费流水",
    pageTitle: "消费流水",
  }),
  createRoute({
    legacyPath: "/collection/address",
    name: "CollectionAddress",
    viewKey: "collectionAddress",
    code: "collectionAddress",
    title: "收货地址",
    pageTitle: "收货地址",
  }),
  createRoute({
    legacyPath: "/collection/invite",
    name: "CollectionInvite",
    viewKey: "collectionInvite",
    code: "collectionInvite",
    title: "赚取积分",
    pageTitle: "赚取积分",
  }),
  createRoute({
    legacyPath: "/collection/findLogistics",
    name: "FindLogistics",
    viewKey: "collectionFindLogistics",
    code: "FindLogistics",
    title: "物流查询",
    pageTitle: "物流查询",
  }),
  createRoute({
    legacyPath: "/collection/rechargeWallet",
    name: "CollectionRechargeWallet",
    viewKey: "collectionRechargeWallet",
    code: "collectionRechargeWallet",
    title: "快捷充值",
    pageTitle: "快捷充值",
  }),
  createRoute({
    legacyPath: "/collection/recharge",
    name: "CollectionRecharge",
    viewKey: "collectionRecharge",
    code: "collectionRecharge",
    title: "快捷充值",
    pageTitle: "快捷充值",
  }),
  createRoute({
    legacyPath: "/collection/coupons",
    name: "CollectionCoupons",
    viewKey: "collectionCoupons",
    code: "collectionCoupons",
    title: "优惠券",
    pageTitle: "优惠券",
  }),
  createRoute({
    legacyPath: "/collection/points",
    name: "CollectionPoints",
    viewKey: "collectionPoints",
    code: "collectionPoints",
    title: "积分",
    pageTitle: "积分",
  }),
  createRoute({
    legacyPath: "/collection/payOrder",
    name: "CollectionPayOrder",
    viewKey: "collectionPayOrder",
    code: "collectionPayOrder",
    title: "应付账单",
    pageTitle: "应付账单",
  }),
  createRoute({
    legacyPath: "/collection/declaration",
    name: "CollectionDeclaration",
    viewKey: "collectionDeclaration",
    code: "collectionDeclaration",
    title: "发起集运",
    pageTitle: "发起集运",
  }),
  createRoute({
    legacyPath: "/collection/proxy",
    name: "CollectionProxy",
    viewKey: "collectionProxy",
    code: "collectionProxy",
    title: "代理中心",
    pageTitle: "代理中心",
  }),
  createRoute({
    legacyPath: "/collection/withdrawCash",
    name: "WithdrawCash",
    viewKey: "collectionWithdrawCash",
    code: "withdrawCash",
    title: "代理提现",
    pageTitle: "代理提现",
  }),
  createRoute({
    legacyPath: "/collection/ReturnPackage",
    name: "CollectionReturnPackage",
    viewKey: "collectionReturnPackage",
    title: "退货包裹",
    pageTitle: "退货包裹",
  }),
];

export const userCenterRouteNameSet = new Set(
  userCenterRouteDefs.map(route => route.name),
);

const migratedLegacyPrefixes = ["/mall", "/collection", "/login"];
const canonicalLegacyPathMap = new Map(
  userCenterRouteDefs.map(route => [route.legacyPath.toLowerCase(), route.legacyPath]),
);

function splitPathAndSuffix(path: string) {
  const match = String(path || "").match(/^([^?#]*)(.*)$/);
  return {
    pathname: match?.[1] || "",
    suffix: match?.[2] || "",
  };
}

function normalizePathname(pathname: string) {
  if (!pathname) {
    return "/";
  }
  return pathname.startsWith("/") ? pathname : `/${pathname}`;
}

function normalizeLocalAbsolutePath(path = "") {
  if (!/^(https?:)?\/\//.test(path)) {
    return path;
  }

  try {
    const base = typeof window !== "undefined" ? window.location.origin : "http://localhost";
    const url = new URL(path, base);
    const currentHost = typeof window !== "undefined" ? window.location.host : "";
    const isCurrentHost = currentHost && url.host === currentHost;
    const isLocalDevHost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(url.hostname);

    if (isCurrentHost || isLocalDevHost) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  }
  catch {
    return path;
  }

  return path;
}

function matchesPrefix(pathname: string, prefixes: string[]) {
  return prefixes.some(prefix =>
    pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function stripUserCenterBase(path = "") {
  if (!path.startsWith(USER_CENTER_BASE_PATH)) {
    return path;
  }
  const result = path.slice(USER_CENTER_BASE_PATH.length);
  return result || "/";
}

export function legacyPathToUserCenterPath(path = "") {
  if (!path) {
    return path;
  }
  const normalizedLocalPath = normalizeLocalAbsolutePath(path);
  if (/^(https?:)?\/\//.test(normalizedLocalPath)) {
    return normalizedLocalPath;
  }
  if (path.startsWith(USER_CENTER_BASE_PATH)) {
    return path;
  }
  if (normalizedLocalPath.startsWith(USER_CENTER_BASE_PATH)) {
    return normalizedLocalPath;
  }
  const { pathname, suffix } = splitPathAndSuffix(normalizedLocalPath);
  const normalizedPathname = normalizePathname(pathname);

  if (
    normalizedPathname.toLowerCase() === "/mall/estimation"
    || normalizedPathname.toLowerCase() === "/collection/estimation"
  ) {
    return `/collection/estimation${suffix}`;
  }

  if (normalizedPathname === "/sub" || normalizedPathname === "/sub/") {
    return `${USER_CENTER_BASE_PATH}${suffix}`;
  }

  const pathWithoutSubPrefix = normalizedPathname.startsWith("/sub/")
    ? normalizePathname(normalizedPathname.slice(4))
    : normalizedPathname;

  if (pathWithoutSubPrefix.toLowerCase() === "/mall/detail1688") {
    const queryPart = suffix.startsWith("?") ? suffix.slice(1).split("#")[0] : "";
    const hashPart = suffix.includes("#") ? suffix.slice(suffix.indexOf("#")) : "";
    const params = new URLSearchParams(queryPart);
    const detailId = params.get("detailId") || params.get("id") || params.get("offerId");

    if (detailId) {
      params.delete("id");
      params.delete("offerId");
      params.set("detailId", detailId);
    }

    const nextQuery = params.toString();
    return `/product${nextQuery ? `?${nextQuery}` : ""}${hashPart}`;
  }

  const canonicalLegacyPath = canonicalLegacyPathMap.get(pathWithoutSubPrefix.toLowerCase())
    || pathWithoutSubPrefix;

  if (matchesPrefix(canonicalLegacyPath, migratedLegacyPrefixes)) {
    return `${USER_CENTER_BASE_PATH}${canonicalLegacyPath}${suffix}`;
  }

  return path;
}

export function normalizeLegacyLocation(to: RouteLocationRaw): RouteLocationRaw {
  if (typeof to === "string") {
    return legacyPathToUserCenterPath(to);
  }

  if (to && typeof to === "object" && "path" in to && typeof to.path === "string") {
    return {
      ...to,
      path: legacyPathToUserCenterPath(to.path),
    };
  }

  return to;
}

export function getUserCenterRouteByViewKey(viewKey = "") {
  return userCenterRouteDefs.find(route => route.viewKey === viewKey);
}

export function getUserCenterRouteByName(name = "") {
  return userCenterRouteDefs.find(route => route.name === name);
}
